<template>
  <div class="sm-auth">
    <notification-elem />
    <div class="sm-auth__main">
      <div class="sm-auth__main-inner">
        <a
          :href="provider.website_url || '/sign-up'" 
          class="sm-auth__main-logo"
          target="_blank"
        >
          <img-loader :src="logo" />
        </a>

        <router-view />

        <div class="sm-auth__main-sign-up">
          <span>Don't have an account?</span>&nbsp;
          <a
            class="sm-link sm-link-blue" 
            href="/sign-up"
            @click.prevent="$router.push('/sign-up')"
          >Sign up</a>
        </div>
        <div v-show="showOfferings" class="sm-auth__offerings">
          <router-link :to="{ path: '/get_voffice' }" class="sm-link sm-link-blue">View Offered Plans</router-link>
        </div>
      </div>
      <div v-if="Object.keys(provider) && !provider.vanity_domain_custom" class="sm-auth__main-footer">
        <div class="sm-auth__main-footer-links">
          <a :href="links.about" target="_blank">About</a>
          <a :href="links.terms" target="_blank">Terms of service</a>
          <a :href="links.policy" target="_blank">Privacy policy</a>
          <a :href="links.careers" target="_blank">Careers</a>
        </div>
        <div class="sm-auth__main-footer-rights">SphereMail, Inc. ©2011-{{new Date().getFullYear()}} All rights reserved</div>
      </div>
    </div>
    <div class="sm-auth__img-wrap" :style="{ 'background': overlayColor }">
      <div class="sm-auth__img" :class="{'sm-auth__img--fill':provider.background_image_url?true:false}" :style="{ 'background-image': `url(${loginBackground})` }"></div>
    </div>
</div>
</template>

<script>
import Urls from "@/settings/urls";
import { mapActions, mapGetters } from 'vuex';
import imageStore from '@/utils/image-store';
import ImgLoader from '@/components/ImgLoader';
import {GetAllPlans} from '@/api/plans';
import colors from '@/settings/colors';
import {GenerateSysColors} from '@/utils/colors';
import defaultLoginBackground from '@/assets/images/auth/auth.png'

export default {
  name: 'auth',
  components: {
    'notification-elem': () => import('@/components/Notification'),
    'img-loader': ImgLoader
  },
  data() {
    return {
      logo: '',
      links: {
        about: Urls.links.about,
        terms: Urls.links.terms,
        policy: Urls.links.policy,
        careers: Urls.links.careers
      },
      showOfferings: false,
      colors: colors,
      loginBackground:"",
      overlayColor:""
    };
  },
  created() {
    // this.setDefaultColorScheme();
    this.getProvider().then((res)=>{
      this.overlayColor =  res.client.background_image_url ? `transparent`:`var(--sys)`
      this.loginBackground = res.client.background_image_url || defaultLoginBackground
    }).catch(err => {
      console.log(err)
      this.overlayColor = `var(--sys)`
      this.loginBackground = defaultLoginBackground
    })
      .then(res => {
        this.logo = imageStore(this.provider.image_url);
        return GetAllPlans()
          .then(res => {
            if(res.plans && this.hasPaidPlansOnly(res.plans)) this.showOfferings = true;
          });
      });
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      colorScheme: 'general/colorScheme'
    }),
    color() {
      let res = this.colorScheme.color || this.colorScheme.theme;

      if (this.colors[res])
        return this.colors[res];
      else
        return GenerateSysColors(res);
    }
  },
  methods: {
    ...mapActions({
      getProvider: 'getProvider',
      setDefaultColorScheme: 'general/setDefaultColorScheme'
    }),
    hasPaidPlansOnly(plans) {
      return plans.length && !plans.some(plan => 
        plan.subscription_price === 0 || plan.period_amount === 0
      );
    }
  }
}
</script>
<style lang="scss">
@use "@/assets/scss/general/mixins.scss" as *;
@use "@/assets/scss/framework/scss-variables.scss" as *;
@use "@/assets/scss/auth/_auth.scss";

.sm-auth {
  position: relative;

  .sm-notification {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
}
</style>
